'use client'; // Mark as client component for Next.js

import { useState, useEffect } from 'react';
import Image, { StaticImageData } from 'next/image';
import { getImageUrl } from "@/lib/imageUrl";


const AboutTestimonials: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [autoSlideKey, setAutoSlideKey] = useState(0); // To reset interval

  // Sample card data (Tamil)
const cards: {
  id: number;
  front: { text: string; store: string; title: string; avatar: string }; // Changed to string
  back: string;
}[] = [
  {
    id: 1,
    front: {
      text: "Our business website went from outdated to cutting-edge in no time. The team understood our vision and delivered a seamless, fast, and beautifully designed site. Highly recommended!",
      store: 'Magizh Handicrafts',
      title: 'Ganapathi (CEO & Founder)',
      avatar: getImageUrl("/vilvabusiness/website/common/testimonials/magizh.webp"),
    },
    back: 'Back 1',
  },
  {
    id: 2,
    front: {
      text: 'I recently got my website developed by Vilva Business, and I must say, their service was outstanding! From the initial consultation to the final launch, the team was highly professional, responsive, and creative.',
      store: 'Zemdrop',
      title: 'Yuvraj (CEO & Founder)',
      avatar: getImageUrl("/vilvabusiness/website/common/testimonials/zemdrop.webp"),
    },
    back: 'Back 2',
  },
  {
    id: 3,
    front: {
      text: 'A game-changer for our online presence. The design is sleek, and the functionality is top-notch!',
      store: 'Ayyawins',
      title: 'Ram Dhanapal (CEO & Founder)',
      avatar: getImageUrl("/vilvabusiness/website/common/testimonials/ram.webp"),
    },
    back: 'Back 3',
  },
  {
    id: 4,
    front: {
      text: 'I give Vilva D2C a 5/5 rating and have already recommended them to family and friends. I will continue to recommend them to everyone. Their technical team is supportive, interactive, and always goes above and beyond to fulfill our requirements.',
      store: 'Adyarhandicrafts',
      title: 'Manikandan (CEO & Founder)',
      avatar: getImageUrl("/vilvabusiness/website/common/testimonials/adyar.webp"),
    },
    back: 'Back 4',
  },
  {
    id: 5,
    front: {
      text: 'Vilva Team is building my E-Commerce website and getting great support, understanding my requirements. I see good progress with timely updates. Satisfied with their amazing service.',
      store: 'A & G',
      title: 'Ananda (CEO & Founder)',
      avatar: getImageUrl("/vilvabusiness/website/common/testimonials/ag.webp"),
    },
    back: 'Back 5',
  },
  {
    id: 6,
    front: {
      text: 'The services provided by Vilva networks are exceptional. They offer 24/7 service and ensure accountability and thorough monitoring. The technical team is highly interactive, addressing queries promptly and efficiently.',
      store: 'Nalsshoppy',
      title: 'Sivasamy (CEO & Founder)',
      avatar: getImageUrl("/vilvabusiness/website/common/testimonials/siva.webp"),
    },
    back: 'Back 6',
  },
  {
    id: 7,
    front: {
      text: 'The development of the Thaithingal website has experienced significant growth over the last decade, thanks to Vilva Networks commitment',
      store: 'Thaithingal',
      title: 'Manikandan (CEO & Founder)',
      avatar: getImageUrl("/vilvabusiness/website/common/testimonials/thaithingal.webp"),
    },
    back: 'Back 7',
  },
  {
    id: 8,
    front: {
      text: 'Vilva Network is building my e commerce website ad getting a great support to understand my exact requirements. They are providing me with regular update in timely manner. Wishing you to continue provide the excellent support with same team spirit.',
      store: 'Jonas International',
      title: 'Oliver Fernandes (CEO & Founder)',
      avatar: getImageUrl("/vilvabusiness/website/common/testimonials/jonsInternatinal.webp"),
    },
    back: 'Back 8',
  },
];


  // Auto-slide every 4 seconds, reset on autoSlideKey change
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % cards.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [cards.length, autoSlideKey]);

  // Handle next and previous button clicks, reset timer
  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % cards.length);
    setAutoSlideKey((k) => k + 1);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + cards.length) % cards.length);
    setAutoSlideKey((k) => k + 1);
  };

  return (
    <>
      <div className="flex justify-center items-center relative">
        <div className="relative h-[400px] md:h-[300px] perspective-1000 w-full max-w-[500px] mx-auto">
          {cards.map((card, index) => {
            const position = (index - currentIndex + cards.length) % cards.length;
            let transform = '';
            let zIndex = 0;
            let opacity = 1; // Consistent height for all cards

            if (position === 0) {
              transform = 'translateX(0) rotateY(0deg) scale(1)';
              zIndex = 10;
              opacity = 1;
            } else if (position === 1) {
              transform = 'translateX(14%) rotateY(-30deg) scale(0.9)'; // Next slide on right
              zIndex = 5;
              opacity = 0.7;
            } else if (position === cards.length - 1) {
              transform = 'translateX(-14%) rotateY(30deg) scale(0.9)'; // Previous slide on left
              zIndex = 5;
              opacity = 0.7;
            } else {
              transform = 'translateX(0) rotateY(0deg) scale(0.8)';
              opacity = 0;
              zIndex = 0;
            }

            return (
              <div
                key={card.id}
                className="absolute w-full md:w-[600px] lg:w-[650px] mx-auto overflow-hidden transition-all duration-500 ease-in-out rounded-[16px] border border-[#E4E9F0] h-[400px] md:h-[300px] bg-white shadow-[0px_68px_19px_0px_rgba(0,9,56,0),0px_43px_17px_0px_rgba(0,9,56,0),0px_24px_15px_0px_rgba(0,9,56,0.01),0px_11px_11px_0px_rgba(0,9,56,0.02),0px_3px_6px_0px_rgba(0,9,56,0.02)]"
                style={{
                  transform,
                  transformStyle: 'preserve-3d',
                  zIndex,
                  opacity,
                  left: '50%',
                  transformOrigin: 'center',
                  translate: '-50%',
                }}
              >
                <div
                  className="flex w-full md:w-[600px] lg:w-[650px] p-[32px] flex-col justify-between items-start flex-shrink-0 rounded-[16px] border border-[#E4E9F0] h-[400px] md:h-[300px] bg-white shadow-[0px_68px_19px_0px_rgba(0,9,56,0),0px_43px_17px_0px_rgba(0,9,56,0),0px_24px_15px_0px_rgba(0,9,56,0.01),0px_11px_11px_0px_rgba(0,9,56,0.02),0px_3px_6px_0px_rgba(0,9,56,0.02)]"
                >
                  <p className="text-[#090D28] text-[20px] md:text-[20px] leading-[150%] schibsted-grotesk font-semibold">
                    {card.front.text}
                  </p>
                  <div className="flex gap-4 items-center">
                    <Image
                      className="object-cover w-14 h-14 rounded-full"
                      src={card.front.avatar}
                      alt={`${card.front.store} avatar`}
                      width={56} // Tailwind w-14 = 56px
                      height={56}
                      loading='lazy'
                    />
                    <div>
                      <p className="text-[#090D28] whitespace-nowrap p-0 m-0 mb-1 text-[16px] font-medium leading-none schibsted-grotesk">
                        {card.front.store}
                      </p>
                      <p className="text-[#666] text-[12px] md:text-[14px] p-0 m-0 font-normal leading-none schibsted-grotesk">
                        {card.front.title}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="absolute w-full bg-gray-200 rounded-[16px] flex items-center h-[400px] md:h-[300px] justify-center text-lg text-gray-600"
                  style={{ transform: 'rotateY(180deg)', backfaceVisibility: 'hidden',  }}
                >
                  {card.back}
                </div>
              </div>
            );
          })}

          
        </div>
      </div>

      {/* Mobile Buttons */}
      <div className="flex z-40 mt-6 justify-center gap-[24px] items-center px-4">
        <button
          className="rounded-[18px] border border-[#E4E9F0] bg-white z-40 shadow-[0px_68px_19px_rgba(0,9,56,0),0px_43px_17px_rgba(0,9,56,0),0px_24px_15px_rgba(0,9,56,0.01),0px_11px_11px_rgba(0,9,56,0.02),0px_3px_6px_rgba(0,9,56,0.02)] flex w-[36px] h-[36px] p-2 justify-center items-center aspect-[1/1]"
          onClick={handlePrev}
          type="button"
          aria-label="Next Slide"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M12.5 15L7.5 10L12.5 5"
              stroke="black"
              strokeWidth="1.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <button
          className="rounded-[18px] border border-[#E4E9F0] bg-white z-40 shadow-[0px_68px_19px_rgba(0,9,56,0),0px_43px_17px_rgba(0,9,56,0),0px_24px_15px_rgba(0,9,56,0.01),0px_11px_11px_rgba(0,9,56,0.02),0px_3px_6px_rgba(0,9,56,0.02)] flex w-[36px] h-[36px] p-2 justify-center items-center aspect-[1/1]"
          onClick={handleNext}

          type="button"
          aria-label="Prev Slide"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M7.5 15L12.5 10L7.5 5"
              stroke="black"
              strokeWidth="1.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </>
  );
};

export default AboutTestimonials;